import { UserHouseholdRole } from 'common/generated/graphQlTypes/globalTypes';

export const getDisplayHouseholdRole = (role: UserHouseholdRole) =>
  `Family ${role === UserHouseholdRole.OWNER ? 'Manager' : 'Member'}`;
